<div class="landing-container">
    <div id="header" class="section p-d-flex p-flex-column">
        <table>
            <tr>
                <td width="25%" align="center">
                    <div class="header-menu-container p-shadow-5 p-d-flex p-ai-center p-jc-between">
                        <a class="layout-topbar-logo" routerLink="#">
                            <img src="assets/layout/images/logo2x___.png" alt="ultima-layout" style="height: 70px">
                        </a>
                    </div>
                </td>
                <td align="center" width="75%">
                    <div class="header-text p-d-flex p-flex-column p-ai-center p-jc-left">
                        <h3 class="p-mb-0 white-color">TOV INTERNACIONAL</h3>
                        <h4 class="p-mb-1 white-color">{{event_group_name_}}</h4>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div class="section p-d-flex p-flex-column p-ai-center">
        <h3 class="p-m-0">{{evt?.eventName}}</h3>
    </div>
    <div class="section p-d-flex p-flex-column p-ai-center">
        <h1 class="p-m-0">{{event_msg_success_}}</h1>
    </div>
    <div class="section p-d-flex p-flex-column p-ai-center">
        <h3 class="p-m-0">{{thanks_for_participating_}}</h3>
    </div>
    <div class="section p-d-flex p-flex-column p-ai-center">
        <h3 class="p-m-0">{{descript_date_}}</h3>
    </div>
</div>